export const contactSupportHref = ({ subject, body }: { subject: string; body: string }) =>
    `mailto:support@sofarocean.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
